import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '上游新闻';

const route: RouteConfig = {
  path: '/20200211ZMXL',
  name: 'ZMXL',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'Rules',
      component: () => import('./Rules.vue'),
      name: 'ZMXLRules',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'List',
      component: () => import('./List.vue'),
      name: 'ZMXLList',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: 'ZMXLDetail',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'News',
      component: () => import('./News.vue'),
      name: 'ZMXLNews',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
